import { Producto } from './Producto';

export class StockPorContenedores{
    producto: Producto;
    volumenEnTanques: number;
    volumenEnPoliductos: number;
    volumenEnAbastecedoras: number;
    volumenEnCanerias: number;
    vacio: number = 0;
    promedioDespachado: number;
    stockDias: number;
    warnings: [];
}
